<template>
  <div id="SEbanner" class="carousel slide" data-ride="carousel" data-interval="5000"  style="margin-top: 0px;">

    <!-- 指示符 -->
    <ul class="carousel-indicators">
      <li data-target="#SEbanner" data-slide-to="0" class="active"></li>
      <li data-target="#SEbanner" data-slide-to="1"></li>
      <li data-target="#SEbanner" data-slide-to="2"></li>
      <li data-target="#SEbanner" data-slide-to="3"></li>
      <li data-target="#SEbanner" data-slide-to="4"></li>
      <li data-target="#SEbanner" data-slide-to="5"></li>

    </ul>

    <!-- 轮播图片 -->
    <div class="carousel-inner">

      <div class="carousel-item active" style="cursor: pointer;"  @click="$router.push('/ca/caguzhu')" >
          <img  src="../assets/images/carousel/ca-5.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">加拿大雇主担保移民</h4>
        </div>
      </div>

      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/ca/cakui')" >
          <img src="../assets/images/carousel/ca-3.jpg">
        <div class="carousel-caption" >
          <h4 class="opacityOuterC z-depth-1">加拿大魁省投资移民</h4>
        </div>
      </div>

      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/usa/l1')" >
        <img src="../assets/images/carousel/us-3.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">美国L1签证</h4>
        </div>
      </div>

<!--      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/cy')" >
        <img src="../assets/images/carousel/cy-1.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">塞浦路斯护照移民</h4>
        </div>
      </div>-->

      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/hk')" >
        <img src="../assets/images/carousel/hk-1.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">香港专才计划移居</h4>
        </div>
      </div>

      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/ie')" >
        <img src="../assets/images/carousel/ie-1.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">爱尔兰移民</h4>
        </div>
      </div>

      <div class="carousel-item" style="cursor: pointer" @click="$router.push('/gr')" >
        <img src="../assets/images/carousel/gr-1.jpg">
        <div class="carousel-caption">
          <h4 class="opacityOuterC z-depth-1">希腊购房移民</h4>
        </div>
      </div>

    </div>




    <!-- 左右切换按钮 -->
    <a class="carousel-control-prev" href="#SEbanner" data-slide="prev" style="opacity: 0.3">
      <span class="carousel-control-prev-icon"></span>
    </a>
    <a class="carousel-control-next" href="#SEbanner" data-slide="next" style="opacity: 0.3">
      <span class="carousel-control-next-icon"></span>
    </a>

  </div>

</template>



<script>

  export default {
    name:'MyCarousel',


  };
</script>

<style>
  /* Make the image fully responsive */
  .carousel-inner img {
    width: 100%;
    height: 100%;
  }

  .carousel-item h2, .carousel-item h3{
    color:white;
  }
  .carousel-item button{
    font-weight: bold;
    margin-bottom: 20px;
  }
  .carousel-caption{
    /*padding-bottom: 70px;*/
    text-shadow: 3px 3px 2px black;
    margin-bottom: 2.6em;
    font-weight: 900;
  }
  .carousel-indicators{
    margin-bottom: 20px;
  }
  .carousel-caption h2,.carousel-caption button{
    text-shadow: 1px 1px 6px #000,2px 2px 6px #000,3px 3px 6px #000,4px 4px 6px #000;
    font-weight: bolder;
  }
  .carousel-caption button{
    border: 2px white solid;
  }


  .opacityOuterC {
    background: rgba(0, 0, 0, 0.3) !important;
    filter: Alpha(opacity=30);
    padding-top: 0.4em;
    padding-bottom: 0.4em;
    font-weight: bolder;
  }
</style>
